import { createStore } from 'vuex'

import createPersistedState from "vuex-persistedstate";
import SecureLS from 'secure-ls'
import { Config } from "../models/Config";

import { AxiosService } from '../services/IAxiosService';
import { IAxiosService } from '../interfaces/IAxiosService';

import userstate from './modules/user.store';

const config : Config = require("../../config.json");
const secret : string = config.secret;
var ls = new SecureLS({ encodingType: 'aes', encryptionSecret: secret, isCompression: true });

interface IAxiosServiceState {
  axiosService :  IAxiosService;
}

export default createStore<IAxiosServiceState>({
  state: {
    axiosService : new AxiosService(),
  } as IAxiosServiceState,
  mutations: {
    async createAxiosService (state: IAxiosServiceState, headers : { isAdmin: boolean, adminCookie: string }) {
      state.axiosService = new AxiosService(headers.isAdmin, headers.adminCookie);
      return state.axiosService;
    },
  },
  actions: {
    async createAxiosService (context: any, headers : { isAdmin: boolean, adminCookie: string }) {
      context.commit('createAxiosService', headers);
      return this.state.axiosService;
    },
  },
  modules: {
    userstate,
  },
  plugins: [createPersistedState({ 
    storage: {
      getItem: (key) => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: (key) => ls.remove(key),
    },
    paths: ['userstate.User','userstate.AdminCookie']})],
})